<template>
    <Header></Header>
    <main>
        <BreadCrumbs></BreadCrumbs>
        <MainContentWrapper>
            <template #slider v-if="productData.length > 0"><SliderImages :images="productData[0].images"></SliderImages></template>
            <template #info v-if="productData.length > 0"><MainInfoContent :array="{
                    id: productData[0].id,
                    name: productData[0].name,
                    description: productData[0].description,
                    year: productData[0].year,
                    weight: productData[0].weight,
                    unit_of_measure: productData[0].unit_of_measure,
                    type_of_material: productData[0].type_of_material,
                    category_name: productData[0].category_name,
                    in_wishlist: productData[0].in_wishlist,
                }"
            ></MainInfoContent></template>
        </MainContentWrapper>
        <ProductTabs 
        v-if="productData.length > 0"
        :technical_specifications="productData[0].technical_specifications"
        :tabs_description="productData[0].tabs_description"
        :reviews="productData[0].reviews"
        ></ProductTabs>
        <AlsoLike :fields="fields['Machines']">
            <template #list v-if="alsoLike.length > 0"><ProductList :itemsPerRow="4" :products="alsoLike"></ProductList></template>
        </AlsoLike>
        <FaqBlock style="padding-bottom: 120px;"></FaqBlock>
    </main>
    <Footer></Footer>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import BreadCrumbs from "@/components/UI/BreadCrumbs.vue";
import ProductTabs from "@/components/Product/ProductTabs.vue";
import FaqBlock from "@/components/Templates/FaqBlock.vue";
import AlsoLike from "@/components/Templates/AlsoLike.vue";
import ProductList from "@/components/Products/ProductList.vue";
import MainContentWrapper from "@/components/Product/MainContentWrapper.vue";
import SliderImages from "@/components/Product/Tabs/SliderImages.vue";
import MainInfoContent from "@/components/Product/MainInfoContent.vue";
import axios from "axios";
export default {
    components: {
        Header,
        Footer,
        BreadCrumbs,
        ProductTabs,
        FaqBlock,
        AlsoLike,
        ProductList,
        MainContentWrapper,
        SliderImages,
        MainInfoContent
    },
    data() {
        return {
            productData: [],
            alsoLike: [],
        }
    },
    methods: {
        getData() {
            let fData = new FormData();
            fData.append("slug", this.$route.params.slug);
            axios.post("/get/product-post", fData).then(resp => {
                if (resp.data.result == true) {
                this.productData = resp.data.blog;
                this.updateTitle(this.productData[0].meta_title ? this.productData[0].meta_title : "UBL");
                if(this.productData[0].meta_description){
                    this.updateMetaDescription(this.productData[0].meta_description);
                }
                }
            }).catch(() => {
            }).finally(() => {
            });
        },
        async fetchBlogs() {
                try {
                    let fData = new FormData();
                    fData.append("slug", this.$route.params.slug);
                    const response = await axios.post("/get/our-products",fData);
                    if (response.data.result) {
                    this.alsoLike = response.data.data;
                    }
                } catch (error) {
                    console.error("Ошибка при загрузке блогов:", error);
                }
        },
        updateTitle(title) {
            let titleTag = document.querySelector("title");
            if (!titleTag) {
                titleTag = document.createElement("title");
                document.head.appendChild(titleTag);
            }
            titleTag.textContent = title || "UBL";
        },

        updateMetaDescription(content) {
            let tag = document.querySelector(`meta[name='description']`);
            if (tag) {
                tag.setAttribute("content", content);
            } else {
                tag = document.createElement("meta");
                tag.setAttribute("name", "description");
                tag.setAttribute("content", content);
                document.head.appendChild(tag);
            }
        }
    },
    computed: {
            fields() {
                return this.$store.state.fields;
            },
        },
    mounted () {
        this.getData();
        this.fetchBlogs();
    },
    watch: {
        // Следим за изменением slug в маршруте
        '$route.params.slug': function(newSlug) {
        this.getData(); // Перезапрашиваем пост по новому slug
        },
    },
}
</script>

<style scoped>

</style>